module.exports = __webpack_public_path__ + "static/media/proj_1.7e95c777.png";